exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-promiotion-container[data-v-b0e5d134]{margin:20px 0 0 20px;background:#fff;padding:10px;min-height:calc(100vh - 120px)}.sales-promiotion .err[data-v-b0e5d134]{color:red}", ""]);

// exports
